"use client";
import { noop } from "../../utils/noop/noop.mjs";
import { MantineContext, useMantineStyleNonce } from "../Mantine.context.mjs";
import { use, useCallback, useEffect, useRef } from "react";
import { useColorScheme } from "@mantine/hooks";
//#region packages/@mantine/core/src/core/MantineProvider/use-mantine-color-scheme/use-mantine-color-scheme.ts
function disableTransition(nonce) {
	const style = document.createElement("style");
	style.setAttribute("data-mantine-styles", "inline");
	style.innerHTML = "*, *::before, *::after {transition: none !important;}";
	style.setAttribute("data-mantine-disable-transition", "true");
	nonce && style.setAttribute("nonce", nonce);
	document.head.appendChild(style);
	const clear = () => document.querySelectorAll("[data-mantine-disable-transition]").forEach((element) => element.remove());
	return clear;
}
function useMantineColorScheme({ keepTransitions } = {}) {
	const clearStylesRef = useRef(noop);
	const timeoutRef = useRef(-1);
	const ctx = use(MantineContext);
	const nonceValue = useRef(useMantineStyleNonce()?.());
	if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
	const setColorScheme = (value) => {
		ctx.setColorScheme(value);
		clearStylesRef.current = keepTransitions ? () => {} : disableTransition(nonceValue.current);
		window.clearTimeout(timeoutRef.current);
		timeoutRef.current = window.setTimeout(() => {
			clearStylesRef.current?.();
		}, 10);
	};
	const clearColorScheme = () => {
		ctx.clearColorScheme();
		clearStylesRef.current = keepTransitions ? () => {} : disableTransition(nonceValue.current);
		window.clearTimeout(timeoutRef.current);
		timeoutRef.current = window.setTimeout(() => {
			clearStylesRef.current?.();
		}, 10);
	};
	const osColorScheme = useColorScheme("light", { getInitialValueInEffect: false });
	const computedColorScheme = ctx.colorScheme === "auto" ? osColorScheme : ctx.colorScheme;
	const toggleColorScheme = useCallback(() => setColorScheme(computedColorScheme === "light" ? "dark" : "light"), [setColorScheme, computedColorScheme]);
	useEffect(() => () => {
		clearStylesRef.current?.();
		window.clearTimeout(timeoutRef.current);
	}, []);
	return {
		colorScheme: ctx.colorScheme,
		setColorScheme,
		clearColorScheme,
		toggleColorScheme
	};
}
//#endregion
export { useMantineColorScheme };

//# sourceMappingURL=use-mantine-color-scheme.mjs.map